import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';


const json = {

  1: { // Exercise num
    unit: 'Unit 5',
    id: 'WB4-V2-U5-P34-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 4,
    exerciseKey: 'img/FriendsPlus/Page34/E1/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page34/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page34/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page34/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page34/E1/4.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page34/E1/5.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page34/E1/6.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page34/E1/7.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page34/E1/8.jpg' },
      ]

    ]
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'WB4-V2-U5-P34-E2',
    audio: 'img/FriendsPlus/Page34/Audio/audio-e2-p34.mp3',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page34/E2/Key/answerKey.png',
    component: MatchDots,
    titleQuestion: [{ num: '2', title: 'Listen and draw lines.<headphone name="09" src="img/FriendsPlus/Page34/Audio/tieude-e2-p34.mp3"></headphone>', color: "#5B5A5D" }],
    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [

          { boxMatchStyle: { position: 'absolute', top: '68px', left: '415px', width: 152, height: 97 }, },//keo
          { boxMatchStyle: { position: 'absolute', top: '72px', left: '695px', width: 92, height: 91 }, },//thiep
          { boxMatchStyle: { position: 'absolute', top: '664px', left: '565px', width: 136, height: 97 }, },
          { boxMatchStyle: { position: 'absolute', top: '657px', left: '260px', width: 94, height: 83 }, },//bong
          { boxMatchStyle: { position: 'absolute', top: '249px', left: '252px', width: 243, height: 120, transform: 'rotate(8deg)' }, },//ban
          { boxMatchStyle: { position: 'absolute', top: '270px', left: '558px', width: 100, height: 149 }, },//ghe
          { boxMatchStyle: { position: 'absolute', top: '470px', left: '428px', width: 377, height: 132, borderRadius: '67px' }, },//rug
        ],
        answers: ['0-4', '1-4', '3-5', '2-4'],
        initialValue: [],
      },
      Layout: `
          <img src='img/FriendsPlus/Page34/E2/1.jpg' />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />

          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
      `,
    },
  },


}

export default json;